/**
 * Service module for the Engagement Pages' Content
 * @module ContentService
 *
 * This module contains requests that fetches the starting information of all engagement pages
 */
import { PublisherAxios } from '@/config/axios';

/**
 * Get the content of an engagement action
 * @param {string} action Identifier for the receiver's id
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object represents the engagement action content
 *
 */
export function getContentByAction(action, config = {}) {
  return PublisherAxios.get(`/contents/${action}`, config);
}

export default {
  getContentByAction,
};
